export default __webpack_public_path__ + "static/media/9.1e77ae9e.png";